import type { TSerializedWidget } from 'src/entities/workspace/types';
import { parseTrajectoryWidgetInternalState } from 'src/pages/dashboard/features/trajectory-widget/parseTrajectoryWidget';
import type { TrajectoryWidgetEntity } from 'src/pages/dashboard/features/trajectory-widget/TrajectoryWidget.entity';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function trajectoryApplyChanges(widget: TrajectoryWidgetEntity, changes: TSerializedWidget, index: number) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseTrajectoryWidgetInternalState(changes.internalState);

  widget.setWellId(internalState.wellId ?? changes.wellId ?? null);
  widget.setWellboreId(internalState.wellboreId);
  widget.setTrajectoryId(internalState.trajectoryId);
  widget.setPlanOrFact(internalState.planOrFact);
  widget.setStateParams(internalState.stateParams);
}
